import { render, staticRenderFns } from "./RecordTable.vue?vue&type=template&id=5be2e91d&scoped=true&"
import script from "./RecordTable.vue?vue&type=script&lang=js&"
export * from "./RecordTable.vue?vue&type=script&lang=js&"
import style0 from "./RecordTable.vue?vue&type=style&index=0&id=5be2e91d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be2e91d",
  null
  
)

export default component.exports